import React, { createContext, useContext, useState } from "react";
const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [books, setBooks] = useState([]);
    const [latestBooks, setLatestBooks] = useState([]);

    return (
        <AppContext.Provider
            value={{
                books,
                setBooks,
                latestBooks,
                setLatestBooks
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => useContext(AppContext);